import {
  AfterViewInit,
  Component,
  OnInit,
  QueryList,
  Renderer2,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import {
  AgNumberCountComponent,
  AgActionCellRendererComponent,
  GridWrapperComponent,
} from "../../core/components";
import { DashboardService } from "../dashboard.service";
import { PieChartService } from "../charts/pie-chart.service";
import { RowChartService } from "../charts/row-chart.service";
import { Router } from "@angular/router";
import * as moment from "moment";
import { GLOBAL } from "src/app/app.globals";
import { CookieService } from "ngx-cookie-service";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ContractorDashboardGroupRowComponent } from "./contractor-dashboard-group-row/contractor-dashboard-group-row.component";
import { SharedService } from "src/app/core/services";
import { GridApi, GridOptions } from "ag-grid-community";
import { DatePipe } from "@angular/common";
import { ApiCallService } from "src/app/service/api-call.service";
import { HttpClient } from "@angular/common/http";

declare var d3: any;
declare var dc: any;
declare var crossfilter: any;

@Component({
  selector: "app-contractor-dashboard",
  templateUrl: "./contractor-dashboard.component.html",
  styleUrls: ["./contractor-dashboard.component.css"],
})
export class ContractorDashboardComponent implements OnInit, AfterViewInit {
  @ViewChildren("agGrid")
  public gridWrapperComponents: QueryList<GridWrapperComponent>;

  groupingMeta = ["Contractor"];
  //groupingMetaForDailyRquirement = ['PlantName', 'WorkMenCategory'];
  groupingMetaForDailyRquirement = ["Contractor"];
  userId;
  columnDefs: any[];
  columnDefsForLicence: any[];
  columnDefsForWorkOrder: any[];
  columnDefsDailyRequirement: any[];
  rowData = [];
  rowDataForLicence = [];
  rowDataForWorkOrder = [];
  rowDataForDailyRequirement = [];
  numberOfRowsPerPage = 10;
  pageList = [10, 20, 50, 100];
  gridAPI: GridApi;
  rowClassRules;
  showSpinner: boolean;
  
  // Dashboard data properties (same as HR dashboard)
  totalContractorCount;
  totalPurchaseOrder;
  totalPresentCount;
  spanTotalAvailableCount;
  spanActiveGatePassCount;
  spanTotalMale;
  spanTotalFemale;
  startDate = null;
  endDate = null;
  filteredDate = "";
  
  // Document data properties
  documentData: any[] = [];
  documentColumnDefs: any[] = [];
  
  // Chart properties
  pieSkillWiseChartTotDash;
  barNonComplianceWisePresentStatusChart;
  barDepartmentWiseChartTotDash;
  skillWiseAgGridData;
  
  // Popup/DataTable properties
  showDataTable = false;
  agGridData: Array<any> = [];
  tableColDefs: any[] = [];
  dataTableContractorDimension;
  dataTablePurchaseOrderDimension;
  dataTablePresentDimension;
  dataTableAvailableDimesion;
  dataTableActiveGatePassDimension;
  dataTableNonComplianceDimension;
  totalDashboardNdxAll;
  totalContractorCountData;
  totalPurchaseOrderData;
  filterAllRecords: number = 10000000000000;
  constructor(
    private dashboardService: DashboardService,
    private pieChartService: PieChartService,
    private rowChartService: RowChartService,
    private renderer: Renderer2,
    private cookieService: CookieService,
    private sharedService: SharedService,
    private datePipe: DatePipe,
    private apiCall: ApiCallService,
    private http: HttpClient
  ) {
    this.userId = GLOBAL.USER_ID;
    this.columnDefs = [
      {
        headerName: "#",
        field: "",
        width: 10,
        cellRendererFramework: AgNumberCountComponent,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
      {
        headerName: "Contractor",
        field: "Contractor",
        width: 40,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
        colSpan: (params) => {
          return params.data.parent ? 12 : 1;
        },
        cellRendererFramework: ContractorDashboardGroupRowComponent,
        cellRendererParams: {
          groupingData: this.groupingMeta,
        },
      },
      {
        headerName: "ECPolicy No.",
        field: "Number",
        width: 50,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
      {
        headerName: "Plant",
        field: "Plant",
        width: 50,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
      {
        headerName: "Issue Date",
        field: "IssueDate",
        width: 50,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
      {
        headerName: "Validity Date",
        field: "ValidityDate",
        width: 50,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
      {
        headerName: "Expiry Remaining Days",
        field: "Expiry",
        width: 50,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
    ];
    this.rowData = [];

    this.columnDefsForLicence = [
      {
        headerName: "#",
        field: "",
        width: 10,
        cellRendererFramework: AgNumberCountComponent,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
      {
        headerName: "Contractor",
        field: "Contractor",
        width: 40,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
        colSpan: (params) => {
          return params.data.parent ? 12 : 1;
        },
        cellRendererFramework: ContractorDashboardGroupRowComponent,
        cellRendererParams: {
          groupingData: this.groupingMeta,
        },
      },
      {
        headerName: "Licence NO",
        field: "Number",
        width: 50,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
      {
        headerName: "Plant",
        field: "Plant",
        width: 50,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
      {
        headerName: "Issue Date",
        field: "IssueDate",
        width: 50,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
      {
        headerName: "Validity Date",
        field: "ValidityDate",
        width: 50,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
      {
        headerName: "Expiry Remaining Days",
        field: "Expiry",
        width: 50,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
    ];
    this.rowDataForLicence = [];

    this.columnDefsForWorkOrder = [
      {
        headerName: "#",
        field: "",
        width: 5,
        cellRendererFramework: AgNumberCountComponent,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
      {
        headerName: "Contractor",
        field: "Contractor",
        width: 50,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
        colSpan: (params) => {
          return params.data.parent ? 12 : 1;
        },
        cellRendererFramework: ContractorDashboardGroupRowComponent,
        cellRendererParams: {
          groupingData: this.groupingMeta,
        },
      },
      {
        headerName: "WorkOrder NO",
        field: "Number",
        width: 50,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
      {
        headerName: "Plant",
        field: "Plant",
        width: 50,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
      {
        headerName: "Issue Date",
        field: "IssueDate",
        width: 50,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
      {
        headerName: "Validity Date",
        field: "ValidityDate",
        width: 50,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
      {
        headerName: "Expiry Remaining Days",
        field: "Expiry",
        width: 50,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
    ];
    this.rowDataForWorkOrder = [];

    this.columnDefsDailyRequirement = [
      {
        headerName: "#",
        field: "",
        width: 5,
        cellRendererFramework: AgNumberCountComponent,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
      {
        headerName: "Contractor",
        field: "Contractor",
        width: 40,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
        colSpan: (params) => {
          return params.data.parent ? 12 : 1;
        },
        cellRendererFramework: ContractorDashboardGroupRowComponent,
        cellRendererParams: {
          groupingData: this.groupingMetaForDailyRquirement,
        },
      },
      {
        headerName: "Plant",
        field: "Plant",
        width: 50,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
      // {
      //   headerName: 'Plant', field: 'Plant', width: 50,
      //   cellStyle: { textAlign: 'center' }, headerClass: 'align-center',
      //   colSpan: (params) => {
      //     return params.data.parent ? 12 : 1;
      //   },
      //   cellRendererFramework: ContractorDashboardGroupRowComponent,
      //   cellRendererParams: {
      //     groupingData: this.groupingMetaForDailyRquirement
      //   }
      // },
      {
        headerName: "Category",
        field: "Category",
        width: 50,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
        // colSpan: (params) => {
        //   return params.data.parent ? 12 : 1;
        // },
        // cellRendererFramework: ContractorDashboardGroupRowComponent,
        // cellRendererParams: {
        //   groupingData: this.groupingMetaForDailyRquirement
        // }
      },
      // {
      //   headerName: 'Unit', field: 'Unit', width: 50,
      //   cellStyle: { textAlign: 'center' }, headerClass: 'align-center'
      // },
      {
        headerName: "Department",
        field: "Department",
        width: 50,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
      {
        headerName: "Section",
        field: "SectionName1",
        width: 50,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
      {
        headerName: "Requirement",
        field: "Requirement",
        width: 50,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
      {
        headerName: "Present",
        field: "Present",
        width: 50,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
      {
        headerName: "Shortages",
        field: "Shortage",
        width: 50,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
    ];
    this.rowDataForDailyRequirement = [];
    
    // Document columns
    this.documentColumnDefs = [
      {
        headerName: "#",
        field: "",
        width: 50,
        cellRendererFramework: AgNumberCountComponent,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
      {
        headerName: "Document",
        field: "Document",
        width: 200,
        cellStyle: { textAlign: "left" },
        headerClass: "align-center",
      },
      {
        headerName: "Number",
        field: "Number",
        width: 120,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
      {
        headerName: "Start Date",
        field: "StartDate",
        width: 100,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
      {
        headerName: "End Date",
        field: "EndDate",
        width: 100,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
      {
        headerName: "Expired In Days",
        field: "ExpiredDays",
        width: 120,
        cellStyle: { textAlign: "center" },
        headerClass: "align-center",
      },
    ];
  }
  rowIndexCellRenderer = (params) => {
    if (!params.data.parent) {
      return `<div style="padding: 5px">${params.data.rowIndex}</div>`;
    }
    return "<div></div>";
  };
  ngOnInit() {
    this.startDate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.endDate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.filteredDate = this.datePipe.transform(new Date(), "dd MMM yyyy");
    
    this.loadDashboardData();
    this.loadDocumentData();
    this.GetContractorDashboardNotif();
  }
  
  loadDashboardData() {
    this.getRealtimeHeadcountSummary(this.startDate, this.endDate);
    this.getTotalContractor();
    this.getTotalWorkOrder();
  }
  
  getRealtimeHeadcountSummary(startDate: any, endDate: any) {
    this.dashboardService
      .getRealtimeHeadcountSummary(startDate, endDate)
      .subscribe((res) => {
        this.bindDashboardData(res);
      }, (error) => {
        console.error('Error in getRealtimeHeadcountSummary:', error);
      });
  }
  
  getTotalContractor() {
    this.dashboardService
      .getContractorFilter()
      .subscribe((res) => {
        this.totalContractorCount = res.length;
        this.totalContractorCountData = res;
        const ndxAll = crossfilter(this.totalContractorCountData);
        this.dataTableContractorDimension = ndxAll.dimension((d) => {
          return "All";
        });
      });
  }
  
  getTotalWorkOrder() {
    this.dashboardService
      .getWorkOrderFilterData()
      .subscribe((res) => {
        this.totalPurchaseOrder = res.length;
        this.totalPurchaseOrderData = res;
        const ndxAll = crossfilter(this.totalPurchaseOrderData);
        this.dataTablePurchaseOrderDimension = ndxAll.dimension((d) => {
          return "All";
        });
      });
  }
  
  bindDashboardData(data) {
    const presentData = data.filter((item) => item["In Time"]);
    const availableData = data.filter((item) => item["In Time"] && !item["Out Time"]);
    
    this.totalPresentCount = presentData.length;
    this.spanTotalAvailableCount = availableData.length;
    this.spanActiveGatePassCount = data.length;
    
    this.skillWiseAgGridData = presentData;
    
    const maleCount = presentData.filter(item => 
      item.Gender === "M" || item.Gender === "Male" || item.Gender === "MALE"
    ).length;
    const femaleCount = presentData.filter(item => 
      item.Gender === "F" || item.Gender === "Female" || item.Gender === "FEMALE"
    ).length;
    
    this.spanTotalMale = maleCount;
    this.spanTotalFemale = femaleCount;
    
    // Setup crossfilter dimensions for popups
    const ndxAll = crossfilter(data);
    const ndxPresent = crossfilter(presentData);
    const ndxAvailableHeadCount = crossfilter(availableData);
    
    this.totalDashboardNdxAll = ndxAll;
    
    this.dataTableActiveGatePassDimension = ndxAll.dimension((d) => {
      return "All";
    });
    this.dataTablePresentDimension = ndxPresent.dimension((d) => {
      return "All";
    });
    this.dataTableAvailableDimesion = ndxAvailableHeadCount.dimension((d) => {
      return "All";
    });
    
    if (this.skillWiseAgGridData && this.skillWiseAgGridData.length > 0) {
      setTimeout(() => {
        this.createSkillWiseChart();
        this.createDepartmentWiseChart();
      }, 1000);
    }
  }
  
  loadDocumentData() {
    const apiUrl = `https://clpmsapi.hrrl.spikyarc.net/api/Common/List/SP_Dashboard_Con_ExpireyDetails`;
    
    this.http.post(apiUrl, { UserId: this.userId })
      .subscribe((res: any) => {
        this.documentData = res || [];
      }, (error) => {
        console.error('Error loading document data:', error);
      });
  }

  public ngAfterViewInit(): void {
    this.gridWrapperComponents.forEach((item) => {
      this.renderer.addClass(
        item._elementRef.nativeElement,
        "custom-grid-height"
      );
    });
    
    setTimeout(() => {
      this.initializeCharts();
    }, 2000);
  }
  
  initializeCharts() {
    if (this.skillWiseAgGridData && this.skillWiseAgGridData.length > 0) {
      this.createSkillWiseChart();
      this.createDepartmentWiseChart();
    }
    
    this.loadNonComplianceData();
  }
  
  createSkillWiseChart() {
    if (!this.skillWiseAgGridData || this.skillWiseAgGridData.length === 0) {
      return;
    }
    
    try {
      const ndxPresent = crossfilter(this.skillWiseAgGridData);
      
      this.pieSkillWiseChartTotDash = this.pieChartService.getPieChart({
        crossfilter: ndxPresent,
        filterGroup: "group3",
        chartId: "#pieSkillWiseHeadCountChart",
        groupByProperty: "Skill",
        reduceProperty: null,
        width: 400,
        height: 200,
        legend: true,
        legendValue: true,
        legendPerc: true,
        label: true,
        labelValue: true,
        labelPerc: true,
        innerRadius: 0,
        slicesCap: 4,
        externalLabels: false,
        externalRadiusPadding: 30,
        renderLabel: true,
      });
    } catch (error) {
      console.error('Error creating skill wise chart:', error);
    }
  }
  
  createDepartmentWiseChart() {
    if (!this.skillWiseAgGridData || this.skillWiseAgGridData.length === 0) {
      return;
    }
    
    try {
      const ndxPresent = crossfilter(this.skillWiseAgGridData);
      
      this.barDepartmentWiseChartTotDash = this.rowChartService.getRowChart({
        crossfilter: ndxPresent,
        filterGroup: "group3",
        chartId: "#barDepartmentWiseChartTotDash",
        groupByProperty: "Department",
        reduceProperty: "Code",
        width: 270,
        height: 416,
        gap: 4,
        yAxisLabel: "Department Name",
        xAxisLabel: "Count",
        elasticY: true,
      });
    } catch (error) {
      console.error('Error creating department wise chart:', error);
    }
  }
  
  loadNonComplianceData() {
    this.dashboardService
      .getNonComplianceLabourList(this.startDate, this.endDate)
      .subscribe((res: any) => {
        if (res && res.length > 0) {
          const ndxNonCompliance = crossfilter(res);
          
          this.dataTableNonComplianceDimension = ndxNonCompliance.dimension(
            (d) => {
              return "All";
            }
          );
          
          this.barNonComplianceWisePresentStatusChart =
            this.rowChartService.getRowChart({
              crossfilter: ndxNonCompliance,
              filterGroup: "group1",
              chartId: "#pieNonComplianceStatusChart",
              groupByProperty: "ErrorDetails",
              reduceProperty: "$id",
              width: 300,
              height: 280,
              gap: 4,
              yAxisLabel: "Non-Compliance",
              xAxisLabel: "HC Numbers",
              elasticY: true,
            });
        }
      }, (error) => {
        console.error('Error loading non-compliance data:', error);
      });
  }
  
  onStartDateChange($event) {
    if ($event) {
      this.startDate = this.datePipe.transform($event.value, "yyyy-MM-dd");
      this.endDate = this.datePipe.transform($event.value, "yyyy-MM-dd");
      this.filteredDate = this.datePipe.transform($event.value, "dd MMM yyyy");
      this.loadDashboardData();
      this.loadNonComplianceData();
    }
  }
  
  resetChartAll() {
    this.startDate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.endDate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.filteredDate = this.datePipe.transform(new Date(), "dd MMM yyyy");
    this.loadDashboardData();
    this.loadNonComplianceData();
    this.loadDocumentData();
    this.loadNonComplianceData();
    this.GetContractorDashboardNotif();
  }
  
  showDatatableByChartId(chartId, $event?, openFullScreen?) {
    this.showDataTable = false;
    if ($event) {
      const classList: DOMTokenList =
        $event.target.closest("div.dashboard-card").classList;
      classList.add("fullscreen-chart");
    }
    
    setTimeout(() => {
      if (
        chartId == "totalPresentCount" ||
        chartId == "pieSkillWiseHeadCountChart" ||
        chartId == "barDepartmentWiseChartTotDash"
      ) {
        this.getDataTableRealTimeHeadCountSummary(
          "group3",
          this.dataTablePresentDimension
        );
      } else if (chartId == "spanTotalAvailableCount") {
        this.getDataTableRealTimeHeadCountSummary(
          "group3",
          this.dataTableAvailableDimesion
        );
      } else if (chartId == "spanActiveGatePassCount") {
        this.getDataTableRealTimeHeadCountSummary(
          "group3",
          this.dataTableActiveGatePassDimension
        );
      } else if (chartId == "totalContractorCount") {
        this.getDataTableContractor(
          "group3",
          this.dataTableContractorDimension
        );
      } else if (chartId == "totalPurchaseOrder") {
        this.getDataTableWorkOrder(
          "group3",
          this.dataTablePurchaseOrderDimension
        );
      } else if (chartId == "pieNonComplianceStatusChart") {
        this.getDataTableNonCompliance(
          "group3",
          this.dataTableNonComplianceDimension
        );
      } else if (chartId == "spanTotalMale" || chartId == "spanTotalFemale") {
        this.getDataTableGenderWise(chartId);
      }
    }, 100);
  }
  
  getDataTableRealTimeHeadCountSummary(groupId, dimension) {
    this.tableColDefs = [
      {
        headerName: "#",
        field: "",
        width: 5,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
        cellRendererFramework: AgNumberCountComponent,
      },
      {
        headerName: "Contractor",
        field: "Contractor",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
      {
        headerName: "Work Order",
        field: "MainWO",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
      {
        headerName: "Code",
        field: "Code",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
      {
        headerName: "Associate",
        field: "Associate",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
      {
        headerName: "Gender",
        field: "Gender",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
      {
        headerName: "Skill",
        field: "Skill",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
      {
        headerName: "Trade",
        field: "Trade",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
      {
        headerName: "Department",
        field: "Department",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
      {
        headerName: "State",
        field: "State",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
      {
        headerName: "In Time",
        field: "In Time",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
      {
        headerName: "Out Time",
        field: "Out Time",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
    ];
    
    this.showDataTable = true;
    this.agGridData = dimension.top(this.filterAllRecords);
  }
  
  getDataTableContractor(groupId, dimension) {
    this.tableColDefs = [
      {
        headerName: "#",
        field: "",
        width: 5,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
        cellRendererFramework: AgNumberCountComponent,
      },
      {
        headerName: "Company",
        field: "Company",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
      {
        headerName: "EmailID",
        field: "EmailID",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
      {
        headerName: "ShortCode",
        field: "ShortCode",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
      {
        headerName: "PANNo",
        field: "PANNo",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
      {
        headerName: "Status",
        field: "Status",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
    ];
    this.showDataTable = true;
    this.agGridData = dimension.top(this.filterAllRecords);
  }
  
  getDataTableWorkOrder(groupId, dimension) {
    this.tableColDefs = [
      {
        headerName: "#",
        field: "",
        width: 5,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
        cellRendererFramework: AgNumberCountComponent,
      },
      {
        headerName: "Work Order No",
        field: "WorkOrderNo",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
      {
        headerName: "Company Name",
        field: "CompanyName",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
      {
        headerName: "Owner",
        field: "Owner",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
      {
        headerName: "Order Start Date",
        field: "OrderStartDate",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
      {
        headerName: "Order End Date",
        field: "OrderEndDate",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
    ];
    this.showDataTable = true;
    this.agGridData = dimension.top(this.filterAllRecords);
  }
  
  getDataTableNonCompliance(groupId, dimension) {
    this.tableColDefs = [
      {
        headerName: "#",
        field: "",
        width: 5,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
        cellRendererFramework: AgNumberCountComponent,
      },
      {
        headerName: "Plant",
        field: "Plant",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
      {
        headerName: "Contractor",
        field: "Contractor",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
      {
        headerName: "Code",
        field: "Code",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
      {
        headerName: "Associate",
        field: "Associate",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
      {
        headerName: "Error Details",
        field: "ErrorDetails",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
    ];
    this.showDataTable = true;
    this.agGridData = dimension.top(this.filterAllRecords);
  }
  
  getDataTableGenderWise(chartId) {
    this.tableColDefs = [
      {
        headerName: "#",
        field: "",
        width: 5,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
        cellRendererFramework: AgNumberCountComponent,
      },
      {
        headerName: "Contractor",
        field: "Contractor",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
      {
        headerName: "Code",
        field: "Code",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
      {
        headerName: "Associate",
        field: "Associate",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
      {
        headerName: "Gender",
        field: "Gender",
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
      },
    ];
    
    this.showDataTable = true;
    const allData = this.dataTablePresentDimension.top(this.filterAllRecords);
    
    if (chartId === "spanTotalMale") {
      this.agGridData = allData.filter(item => 
        item.Gender === "M" || item.Gender === "Male" || item.Gender === "MALE"
      );
    } else if (chartId === "spanTotalFemale") {
      this.agGridData = allData.filter(item => 
        item.Gender === "F" || item.Gender === "Female" || item.Gender === "FEMALE"
      );
    }
  }
  
  cancelFullscreen($event, chart?) {
    this.showDataTable = false;
    this.agGridData = [];
    
    if (chart) {
      // Reset chart dimensions if needed
    }
    
    if ($event) {
      const classList: DOMTokenList =
        $event.target.closest("div.dashboard-card").classList;
      classList.remove("fullscreen-chart");
    }
  }
  
  showFullscreen($event, chart?) {
    if (chart) {
      // Expand chart dimensions if needed
    }
    
    const classList: DOMTokenList =
      $event.target.closest("div.dashboard-card").classList;
    classList.add("fullscreen-chart");
  }
  
  showChart() {
    this.showDataTable = false;
    this.agGridData = [];
  }
  
  resetChart(chart, group?) {
    const group2 = group ? group : "group3";
    if (chart) {
      chart.filterAll(group2);
      dc.redrawAll(group2);
    }
  }
  
  formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  // tslint:disable-next-line: function-name
  GetEXPolicyDataForDashboard() {
    this.dashboardService
      .GetEXPolicyDataForDashboard(this.userId)
      .subscribe((res: []) => {
        if (res.length > 0) {
          // const tempRowData = this.sharedService.agGridGroupRowOnProperties(this.groupingMeta, res);
          // this.rowData = tempRowData;
        }
      });
  }

  // tslint:disable-next-line: function-name
  GetLicenceDataForDashboard() {
    this.dashboardService
      .GetLicenceDataForDashboard(this.userId)
      .subscribe((res: []) => {
        if (res.length > 0) {
          // const tempRowDataForLicence = this.sharedService.agGridGroupRowOnProperties(this.groupingMeta, res);
          // this.rowDataForLicence = tempRowDataForLicence;
        }
      });
  }

  // tslint:disable-next-line: function-name
  GetWorkOrderDataForDashboard() {
    this.dashboardService
      .GetWorkOrderDataForDashboard(this.userId)
      .subscribe((res: []) => {
        if (res.length > 0) {
          // const tempRowDataForWorkOrder = this.sharedService.agGridGroupRowOnProperties(this.groupingMeta, res);
          // this.rowDataForWorkOrder = tempRowDataForWorkOrder;
        }
      });
  }

  // tslint:disable-next-line: function-name
  GetDailyRequirementForDashboard() {
    this.dashboardService
      .GetDailyRequirementForDashboard(this.userId)
      .subscribe((res: []) => {
        if (res && res.length > 0) {
          // const tempRowDataForDailyRequirment = this.sharedService.agGridGroupRowOnProperties(this.groupingMetaForDailyRquirement, res);
          // this.rowDataForDailyRequirement = tempRowDataForDailyRequirment;
        }
        // setTimeout(() => {
        //   console.log('gridWrapperComponent', this.gridWrapperComponent);
        //   this.renderer.addClass(this.gridWrapperComponent._elementRef.nativeElement, 'custom-grid-height');
        // }, 500)
      });
  }
  GetContractorDashboardNotif() {
    this.dashboardService
      .GetContractorDashboardNotif(this.userId)
      .subscribe((res: []) => {
        if (res) {
          // work order
          if (res["Table1"].length > 0) {
            const tempRowDataForWorkOrder =
              this.sharedService.agGridGroupRowOnProperties(
                this.groupingMeta,
                res["Table1"]
              );
            this.rowDataForWorkOrder = tempRowDataForWorkOrder;
          }

          // licence
          if (res["Table2"].length > 0) {
            const tempRowDataForLicence =
              this.sharedService.agGridGroupRowOnProperties(
                this.groupingMeta,
                res["Table2"]
              );
            this.rowDataForLicence = tempRowDataForLicence;
          }

          // ecpolicy
          if (res["Table3"].length > 0) {
            const tempRowData = this.sharedService.agGridGroupRowOnProperties(
              this.groupingMeta,
              res["Table3"]
            );
            this.rowData = tempRowData;
          }

          // daily total requirment
          if (res["Table4"].length > 0) {
            const tempRowDataForDailyRequirment =
              this.sharedService.agGridGroupRowOnProperties(
                this.groupingMetaForDailyRquirement,
                res["Table4"]
              );
            this.rowDataForDailyRequirement = tempRowDataForDailyRequirment;
          }
        }
      });
  }
}
